import type { HeadingItem } from '@/lib/format'
import { useEffect, useState } from 'react'

export function TableOfContents({ items }: { items: HeadingItem[] }) {
  const [activeId, setActiveId] = useState<string | null>(null)

  useEffect(() => {
    if (items.length === 0) return
    let frame = 0
    function update() {
      frame = 0
      let current: string | null = items[0]?.id ?? null
      for (const item of items) {
        const element = document.getElementById(item.id)
        if (!element) continue
        if (element.getBoundingClientRect().top <= 120) current = item.id
        else break
      }
      setActiveId(current)
    }
    function onScroll() {
      if (!frame) frame = window.requestAnimationFrame(update)
    }
    update()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [items])

  if (items.length === 0) return null

  return (
    <nav className="toc" aria-label="On this page">
      <div className="rail-label">On this page</div>
      <ul>
        {items.map(item => (
          <li key={item.id} className={item.depth ? 'toc-nested' : undefined}>
            <a
              href={`#${item.id}`}
              className={item.id === activeId ? 'is-active' : undefined}
              onClick={event => {
                event.preventDefault()
                document
                  .getElementById(item.id)
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
                window.history.replaceState(null, '', `#${item.id}`)
              }}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  )
}
